import React from 'react'
import { observer } from 'mobx-react-lite'
import { Renderer } from '@app/views/Renderer'

export const Labels = observer(({ renderer }: { renderer: Renderer }) => (
  <>
    {renderer.labels.map((label, i) => (
      <text
        className={label.className}
        key={i}
        transform={
          label.rotate
            ? `translate(${label.x + 6} ${label.y + 12}) rotate(-45)`
            : `translate(${label.x - 5} ${label.y + 5})`
        }
      >
        {label.text}
      </text>
    ))}
  </>
))
